import { Modal, TableCustom } from "../../common"
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToIdentificador } from "../../../utils/convert"
import { ServerRequest } from "../../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import { useEffect, useState } from "react"
import { useEntidad, useManagedContext } from "../../hooks"
import ReciboPublicacionModal from "../ReciboPublicacionModal"


const RegistrosContablesGridModal = ({ idRegistroContableLote, onCancel }) => {
    
    const { setIsLoading, showMessageModal } = useManagedContext()

    const [registrosContables, setRegistrosContables] = useState([])
    const [lotes, setLotes] = useState([])
    const [idReciboPublicacion, setIdReciboPublicacion] = useState(null)

    const [, getRowEntidad] = useEntidad({
        entidades: ['Recaudadora'],
        onLoaded: (_, isSuccess, error) => {
            if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: {
            key: 'Recaudadora',
            timeout: 0
        }
    })

    useEffect(() => {
        if (idRegistroContableLote > 0) {
            SearchRecuadaciones(idRegistroContableLote)
        }
    }, [])

    const fetchLote = (id) => new Promise((resolve, reject) => {
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.RECAUDACION_LOTE,
            `/${id}`,
            null,
            res => res.json().then(resolve),
            res => reject(res),
            err => reject(err),
        )
    })

    const SearchLotes = (data) => {
        const idsRecaudacionLote = [...new Set(
            data
                .map(item => item.recaudacion?.idRecaudacionLote)
                .filter(Boolean)
        )]

        if (idsRecaudacionLote.length === 0) {
            setIsLoading(false)
            return
        }

        Promise.all(idsRecaudacionLote.map(fetchLote))
            .then(result => {
                setLotes(result)
                setIsLoading(false)
            })
            .catch(err => {
                onRequestError(err)
                setIsLoading(false)
            })
    }

    const SearchRecuadaciones = (idRegistroContableLote) => {
        setIsLoading(true)

        const paramsUrl = `/detalle/${idRegistroContableLote}`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.REGISTRO_CONTABLE_LOTE,
            paramsUrl,
            null,
            res => res.json().then(data => {
                setRegistrosContables(data)
                SearchLotes(data)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onView: (item) => {
            if (item.recaudacion?.idReciboPublicacion) {
                setIdReciboPublicacion(item.recaudacion.idReciboPublicacion)
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'No existe un VEP de publicación asociado.');
            }
        },
    }

    return (
        <Modal
            onEscape={onCancel}
            allowFullscreen={true}
            size="xl"
            title="Registros contables"
            body={(
                <>
                <TableCustom
                    className={'TableCustomBase m-top-10'}
                    data={lotes}
                    columns={[
                        { Header: 'N° lote recaudación', accessor: 'numeroLote', width: '40%' },
                        { Header: 'Recaudadora', accessor: 'idRecaudadora', width: '40%', Cell: ({ value }) => getRowEntidad('Recaudadora', value)?.nombre ?? '' },
                        { Header: 'Casos', accessor: 'id', width: '20%', Cell: ({ value }) => new Set(registrosContables.filter(r => r.recaudacion?.idRecaudacionLote === value).map(r => getNumeroRecibo_ObjectToIdentificador(r.recaudacion)).filter(Boolean)).size },
                    ]}
                    showFilterGlobal={false}
                    showDownloadCSV={false}
                />

                <TableCustom
                    className={'TableCustomBase m-top-10'}
                    data={registrosContables}
                    avmr={avmr}
                    columns={[
                        { Header: 'Fecha de ingreso', accessor: 'fechaIngreso', Cell: (data) => getDateToString(data.value), width: '15%'},
                        { Header: 'Ejercicio', accessor: 'ejercicio', width: '9%' },
                        { Header: 'Jurisdicción', accessor: 'jurisdiccion', width: '12%' },
                        { Header: 'Recurso por rubro', accessor: 'recursoPorRubro', width: '16%' },
                        { Header: 'Cuenta contable', accessor: 'cuentaContable', width: '14%' },
                        { Header: 'Recaudadora', accessor: 'recaudacion', width: '12%', Cell: ({ row }) => getRowEntidad('Recaudadora', lotes.find(l => l.id === row.original.recaudacion?.idRecaudacionLote)?.idRecaudadora)?.nombre ?? '' },
                        { Header: 'Importe', accessor: 'importe', Cell: (data) => getFormatNumber(data.value, 2), width: '10%', alignCell: 'right' },
                        { Header: 'N° VEP', accessor: 'recaudacion', width: '12%', Cell: ({ row }) =>  getNumeroRecibo_ObjectToIdentificador(row.original.recaudacion) },
                    ]}
                    showDownloadCSV={false}
                />

                {idReciboPublicacion && (
                    <ReciboPublicacionModal
                        id={idReciboPublicacion}
                        onCancel={() => setIdReciboPublicacion(null)}
                    />
                )}
                </>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                </div>
            )}
        />
    )
}

export default RegistrosContablesGridModal
